export default "__VITE_ASSET__CngK50uT__"